"use client";

import React, { useState } from "react";
import { Typography } from "@aph/ui-lib-humanx";
import { HOME_PAGE_TITLE, ONBOARDED_HOME_PAGE_TITLE } from "@/helpers/constants";
import routes from "@/helpers/router";
import Breadcrumbs from "@/components/Breadcrumbs";
import NavBar from "@/components/Header/NavBar";
import { serverReturnType } from "@/components/PageAllResources/interfaces";
import FilterComponent from "@/components/FilterComponent";
import ComponentMapping from "@/components/PageAllResources/componentMapping";
import { getNavBarInfoForCategoryRouting } from "@/helpers";
import { getFilterName } from "@/components/FilterComponent/helpers";
import styles from "./PageAllResources.module.scss";

interface AllResourceListingProps {
  pageInfo: serverReturnType;
  urlFilter: any;
}

const AllResourceListing: React.FC<AllResourceListingProps> = ({ urlFilter, pageInfo }) => {
  const resourcesInfo = pageInfo?.resourcesInfo;
  const userAgent = pageInfo?.ua;
  const userOnBoarded = pageInfo?.userOnBoarded;
  const navBarList = pageInfo?.navBarList;
  const filters = pageInfo?.filterData;

  const navBarInfo = getNavBarInfoForCategoryRouting(navBarList?.data);
  const pathname: string = `${routes.resourcesListing(urlFilter)}`;
  const resourceContent = resourcesInfo?.data?.attributes?.ResourceContent;

  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const filterName = getFilterName(urlFilter, filters);

  const breadCrumbsArray = [
    {
      label: pageInfo?.userOnBoarded ? ONBOARDED_HOME_PAGE_TITLE : HOME_PAGE_TITLE,
      url: routes.home,
    },
    {
      label: "All Resources",
      url: routes.resourcesListing(),
    },
  ];

  return (
    <>
      <NavBar
        navBarData={{ navBarList: navBarInfo }}
        userOnBoarded={userOnBoarded}
        userAgent={userAgent}
        pathname={pathname}
      />
      <div className="container">
        <div className={`breadcrumb`}>
          <Breadcrumbs options={breadCrumbsArray} />
        </div>
        <div className={styles.resources}>
          <div className={styles.titleWrapper}>
            <Typography component="h1" className={styles.title}>
              {`${filterName ? `${filterName} ` : ""}Resources`}
            </Typography>
            <Typography className={styles.filterText} onClick={() => setIsFilterOpen(true)}>
              <span className={"icon-icon-filter"} />
            </Typography>
          </div>
        </div>
        {resourceContent.map((content: any, index: number) => (
          <ComponentMapping data={content} key={index} extras={{ userAgent, userOnBoarded, urlFilter }} />
        ))}
      </div>
      <FilterComponent
        filters={filters}
        urlFilter={urlFilter}
        setIsFilterOpen={setIsFilterOpen}
        isFilterOpen={isFilterOpen}
        userAgent={userAgent}
      />
    </>
  );
};

export default AllResourceListing;
